module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.el, {
    tag: "component",
    attrs: {
      "label": _vm.label,
      "align": _vm.align,
      "prop": _vm.prop,
      "required": _vm.required
    }
  }, [(_vm.noForm && _vm.showLabel) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (!_vm.disabled) ? _c('el-date-picker', {
    ref: _vm.ref,
    attrs: {
      "type": "datetime",
      "placeholder": "Select Date and Time",
      "required": _vm.required
    },
    on: {
      "change": _vm.updated
    },
    model: {
      value: (_vm.formData),
      callback: function($$v) {
        _vm.formData = $$v
      },
      expression: "formData"
    }
  }) : _c('b', [_vm._v(_vm._s(this.formatDateTime(_vm.formData)))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d87fe3f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/inputs/DateTimeInput.vue
// module id = 1418
// module chunks = 0